import { Pencil, Trash } from 'lucide-react'
import { MoreHorizontal } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface Action {
    label: string
    icon?: JSX.Element
    action: () => void
}

interface Submenu {
    title: string
    items: Action[]
}

type TableRowActionsProps = {
    actions?: Action[]
    submenus?: Submenu[]
    onClickDelete?: () => void
    onClickEdit?: () => void
}

const TableRowActions = ({
    actions,
    submenus,
    onClickDelete,
    onClickEdit,
}: TableRowActionsProps) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    className="bg-transparent hover:bg-transparent"
                    size="icon"
                >
                    <span className="sr-only">Open menu</span>
                    <MoreHorizontal className="w-4 h-4 text-foreground" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="border-none" align="end">
                {submenus &&
                    submenus.map((submenu) => (
                        <>
                            <DropdownMenuLabel className="py-1 text-neutral-500">
                                {submenu.title}
                            </DropdownMenuLabel>
                            {submenu.items.map((action, index) => (
                                <DropdownMenuItem
                                    className="gap-2 text-neutral-700"
                                    onClick={action.action}
                                    key={index}
                                >
                                    {action.icon}
                                    {action.label}
                                </DropdownMenuItem>
                            ))}
                            <DropdownMenuSeparator />
                        </>
                    ))}
                <DropdownMenuLabel className="py-1 text-neutral-500">
                    Ações
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                {actions &&
                    actions.map((action, index) => (
                        <DropdownMenuItem
                            className="gap-2 text-neutral-700 cursor-pointer"
                            onClick={action.action}
                            key={index}
                        >
                            {action.icon}
                            {action.label}
                        </DropdownMenuItem>
                    ))}
                {onClickEdit && (
                    <DropdownMenuItem
                        className="gap-2 text-neutral-700 cursor-pointer"
                        onClick={onClickEdit}
                    >
                        <Pencil size={14} />
                        Editar
                    </DropdownMenuItem>
                )}
                {onClickDelete && (
                    <DropdownMenuItem
                        className="gap-2 text-red-500 focus:text-red-500 cursor-pointer"
                        onClick={onClickDelete}
                    >
                        <Trash size={14} />
                        Excluir
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

export default TableRowActions
